import { render } from "./MyPageEmailConfirmation.vue?vue&type=template&id=e64592d4&scoped=true&ts=true"
import script from "./MyPageEmailConfirmation.vue?vue&type=script&lang=ts"
export * from "./MyPageEmailConfirmation.vue?vue&type=script&lang=ts"

import "./MyPageEmailConfirmation.vue?vue&type=style&index=0&id=e64592d4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e64592d4"]])

export default __exports__